import { reduceErrors } from '../errors';

import { ERROR } from '../../constants/product';

export function areComplete(products) {
  function reduceProducts(isComplete, item) {
    return isComplete && item.get('isComplete', true);
  }

  return products.reduce(reduceProducts, true);
}

export function setIsComplete(product) {
  return product.has(ERROR)
    ? product.set('isComplete', !reduceErrors(product.get(ERROR)))
    : product;
}
